// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"ea423293c40403189227","655":"62427de6df4c81f0983c"}[chunkId] + ".js";
};